import { Col, Row } from "reactstrap";

interface Props {
    children: React.ReactNode,
    className: string
}

export const ContentBlock = (props: Props) => {
    return (
        <Row className={`contentContainer ${props.className}`}>
            <Col className="contentContainerCol">
                {props.children}
            </Col>
        </Row>
    );
};
